class Wishlist {
  /**
   * Create wishlist.
   *
   * @param {String} customerId
   * @param {String} listName
   * @returns {Promise<Object|Error>}
   */
  static createWishlist(customerId, listName, attempts = 5) {
    return new Promise((resolve, reject) => {
      fetch('/apps/wishlist/api/create-list', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerId,
          listName,
        }),
      })
        .then((response) => {
          if (attempts > 0 && response.status === 400) {
            return resolve(
              Wishlist.createWishlist(customerId, listName, attempts - 1),
            );
          }
          return response.json();
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  /**
   * Get wishlists.
   *
   * @description If `listId` is provided, it will return the wishlist with the specified ID. Otherwise, it will return all wishlists for the specified customer.
   *
   * @param {String} customerId
   * @param {String} listId?
   * @returns {Promise<Object|Object[]|Error>}
   */
  static getWishlists(customerId, listId, attempts = 5) {
    return new Promise((resolve, reject) => {
      fetch('/apps/wishlist/api/get-list', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerId,
          listId,
        }),
      })
        .then((response) => {
          if (attempts > 0 && response.status === 400) {
            return resolve(
              Wishlist.getWishlists(customerId, listId, attempts - 1),
            );
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
          resolve(data);
        })
        .catch((error) => reject(error));
    });
  }

  /**
   * Delete wishlist.
   *
   * @param {String} wishlistId
   * @returns {Promise<Object|Error>}}
   */
  static deleteWishlist(wishlistId, attempts = 5) {
    return new Promise((resolve, reject) => {
      fetch('/apps/wishlist/api/delete-list', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          wishlistId,
        }),
      })
        .then((response) => {
          if (attempts > 0 && response.status === 400) {
            return resolve(Wishlist.deleteWishlist(wishlistId, attempts - 1));
          }
          return response.json();
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  /**
   * Add to wishlist.
   *
   * @param {String} variantId
   * @param {String} listId
   * @returns {Promise<Object|Error>}
   */
  static addToWishlist(variantId, listId, attempts = 5) {
    return new Promise((resolve, reject) => {
      fetch('/apps/wishlist/api/add-to-list', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          variantId,
          listId,
        }),
      })
        .then((response) => {
          if (attempts > 0 && response.status === 400) {
            return resolve(
              Wishlist.addToWishlist(variantId, listId, attempts - 1),
            );
          }
          return response.json();
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  /**
   * Remove from wishlist.
   *
   * @param {String} variantId
   * @param {String} listId
   * @returns {Promise<Object|Error>}
   */
  static removeFromWishlist(variantId, listId, attempts = 5) {
    return new Promise((resolve, reject) => {
      fetch('/apps/wishlist/api/remove-from-list', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          variantId,
          listId,
        }),
      })
        .then((response) => {
          if (attempts > 0 && response.status === 400) {
            return resolve(
              Wishlist.removeFromWishlist(variantId, listId, attempts - 1),
            );
          }
          return response.json();
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  /**
   * Update in wishlist.
   *
   * @param {String} variantId
   * @param {Object} data - Update data: { quantity: Number }
   * @param {String} listId
   * @returns {Promise<Object|Error>}
   */
  static updateInWishlist(variantId, data, listId, attempts = 5) {
    return new Promise((resolve, reject) => {
      fetch('/apps/wishlist/api/update-quantities', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          variantId,
          data,
          listId,
        }),
      })
        .then((response) => {
          if (attempts > 0 && response.status === 400) {
            return resolve(
              Wishlist.updateInWishlist(variantId, data, listId, attempts - 1),
            );
          }
          return response.json();
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  /**
   * Update DOM.
   */
  static updateDOM() {
    document.querySelector('wishlists-display')?.getWishlists();
    document.querySelector('wishlist-items')?.getWishlists();
  }
}
